import { ClassFlag } from "../dom-tools/ClassFlag";

export class TemplateClassFlag
{
  static readonly invisible = new ClassFlag( "-invisible" );
}